import React, { useState } from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { getIndicator, getIndicatorConfig } from 'utils/common';
import { ListWrapper } from './elements';
import ASB001 from './ASB001';
import ASB002 from 'dc/ASB002';
import Spa16 from 'dc/Spa16';
import { useFormatNumber, useGetActivityIconUrl, useText } from 'common/hooks';
import { INDICATOR } from 'resources/constants';

type Props = {
  readonly eventActivities: string[];
};

const deps = {
  indicator: state.challenge.campaign.indicator,
  activities: state.appContainer.activities,
};

export function ASB000({
  eventActivities,
  activities,
  indicator,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const [showActivities, setShowActivities] = useState(false);
  const formatNumber = useFormatNumber();
  const getActivityIconUrl = useGetActivityIconUrl();
  const t = useText();

  return (
    <div>
      <ASB001
        eventActivities={eventActivities}
        expanded={showActivities}
        onClick={() => setShowActivities(!showActivities)}
      />
      <ListWrapper $show={showActivities}>
        {eventActivities.map(activityKey => {
          const activity = activities[activityKey];

          if (!activity) {
            return (
              <ASB002
                key={activityKey}
                title={t('challenge.activities.no_longer_available')}
                value={'-'}
                icon="icon-leaf"
                color="#E2E3E7"
                activityIcon={`https://static.ducky.eco/SVGIcons/activities/act_placeholder.png`}
                activityUnavailable
              />
            );
          }

          const { color, icon } = getIndicatorConfig(indicator);

          return (
            <ASB002
              key={activityKey}
              title={activity.title}
              value={formatNumber(
                getIndicator(activity.indicators, indicator),
                indicator === INDICATOR.co2 ? 2 : 0
              )}
              icon={icon}
              color={color}
              activityIcon={getActivityIconUrl(activity.icon)}
            />
          );
        })}

        <Spa16 />
      </ListWrapper>
    </div>
  );
}

export default connect<Props, typeof deps>(deps, ASB000);
